import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import "../styles/FormOptions.css";

function FormButtons({ value, onChange }) {
  const [items, setItems] = useState([
    {
      id: 1,
      name: "Charcuterie Plater for 2 - $70",
      selected: false,
      price: 70,
      quantity: 1,
      available: 10,
    },
    {
      id: 2,
      name: "Takeaway Pickup Service - $20",
      selected: false,
      price: 20,
      quantity: 1,
      available: 3,
    },
    {
      id: 3,
      name: "Box of Chocolates",
      selected: false,
      price: 20,
      quantity: 1,
      available: 10,
    },
    {
      id: 4,
      name: "Cake Display White - $5",
      selected: false,
      price: 5,
      quantity: 1,
      available: 1,
    },
    {
      id: 5,
      name: "Cake Display Wood - $5",
      selected: false,
      price: 5,
      quantity: 1,
      available: 1,
    },
    {
      id: 6,
      name: "Cake Display Fillable - $5",
      selected: false,
      price: 5,
      quantity: 1,
      available: 1,
    },
    {
      id: 7,
      name: "Cake Knife Server - $5",
      selected: false,
      price: 5,
      quantity: 1,
      available: 1,
    },
    {
      id: 8,
      name: "Bamboo Tray with Cover - $10",
      selected: false,
      price: 10,
      quantity: 1,
      available: 5,
    },
    {
      id: 9,
      name: "High Tea Stand - $10",
      selected: false,
      price: 10,
      quantity: 1,
      available: 8,
    },
    {
      id: 10,
      name: "High Tea Cup & Saucer Sets $5pp",
      selected: false,
      price: 5,
      quantity: 1,
      available: 20,
    },
    {
      id: 11,
      name: "Iron Stand 2 Tier - $10",
      selected: false,
      price: 10,
      quantity: 1,
      available: 1,
    },
    {
      id: 12,
      name: "Iron Stand 3 Tier - $10",
      selected: false,
      price: 10,
      quantity: 1,
      available: 2,
    },
    {
      id: 13,
      name: "Serving Board Wooden - $10",
      selected: false,
      price: 10,
      quantity: 1,
      available: 5,
    },
    {
      id: 14,
      name: "Drink Dispenser - $10",
      selected: false,
      price: 10,
      quantity: 1,
      available: 3,
    },
    {
      id: 15,
      name: "Ice Bucket with Ice - $16",
      selected: false,
      price: 16,
      quantity: 1,
      available: 5,
    },
    {
      id: 16,
      name: "Bose Speaker - $50",
      selected: false,
      price: 50,
      quantity: 1,
      available: 1,
    },
    {
      id: 17,
      name: "Fresh Floral Arrangement",
      selected: false,
      price: 65,
      quantity: 1,
      available: 10,
    },
    {
      id: 18,
      name: "Signage - $20",
      selected: false,
      price: 20,
      quantity: 1,
      available: 1,
    },
    {
      id: 19,
      name: "Easel White - $20",
      selected: false,
      price: 20,
      quantity: 1,
      available: 1,
    },
    {
      id: 20,
      name: "Easel Natural - $20",
      selected: false,
      price: 20,
      quantity: 1,
      available: 1,
    },
    {
      id: 21,
      name: " Baby Shower Welcome Sign - $70",
      selected: false,
      price: 70,
      quantity: 1,
      available: 1,
    },
    {
      id: 22,
      name: "Baby Ballon Boxes - $70",
      selected: false,
      price: 70,
      quantity: 1,
      available: 1,
    },
    {
      id: 23,
      name: "Macrame Large - $20",
      selected: false,
      price: 20,
      quantity: 1,
      available: 2,
    },
    {
      id: 24,
      name: "Macrame Medium - $20",
      selected: false,
      price: 20,
      quantity: 1,
      available: 4,
    },
    {
      id: 25,
      name: "Arbour Metal - $70",
      selected: false,
      price: 70,
      quantity: 1,
      available: 1,
    },
    {
      id: 26,
      name: "Arbour Natural - $70",
      selected: false,
      price: 70,
      quantity: 1,
      available: 1,
    },
    {
      id: 27,
      name: "Lawn Games - $70",
      selected: false,
      price: 70,
      quantity: 1,
      available: 1,
    },
    {
      id: 28,
      name: "Dining Height Table - $50",
      selected: false,
      price: 50,
      quantity: 1,
      available: 2,
    },
    {
      id: 29,
      name: "Umbrella Market White - $50",
      selected: false,
      price: 50,
      quantity: 1,
      available: 2,
    },
    {
      id: 30,
      name: "Umbrella Lux Light Beige - $50",
      selected: false,
      price: 50,
      quantity: 1,
      available: 5,
    },
    {
      id: 31,
      name: "Umbrella Lux White Fringed - $50",
      selected: false,
      price: 50,
      quantity: 1,
      available: 2,
    },
    {
      id: 32,
      name: "Umbrella Lux Fringed Coloured - $50",
      selected: false,
      price: 50,
      quantity: 1,
      available: 2,
    },
    {
      id: 33,
      name: "Cabana White & Black Stipes - $50",
      selected: false,
      price: 50,
      quantity: 1,
      available: 1,
    },
    {
      id: 34,
      name: "Chair Bamboo Dining Height - $50",
      selected: false,
      price: 50,
      quantity: 1,
      available: 2,
    },
    {
      id: 35,
      name: "Beach Chair Natural - $50",
      selected: false,
      price: 50,
      quantity: 1,
      available: 2,
    },
    {
      id: 36,
      name: "Beach Chair White - $50",
      selected: false,
      price: 50,
      quantity: 1,
      available: 2,
    },
  ]);

  // When a items state changes, lift the state to the parent component
  useEffect(() => {
    if (onChange) {
      const selectedItems = items
        .filter((item) => item.selected)
        .map(({ id, name, quantity, price }) => ({
          id,
          name,
          quantity,
          price,
        }));
      onChange(selectedItems);
    }
  }, [items, onChange]);

  const toggleCheckbox = (id) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, selected: !item.selected } : item,
      ),
    );
  };

  const changeQuantity = (id, qty) => {
    setItems((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          const safeQty = Math.min(Number(qty), item.available);
          return { ...item, quantity: safeQty };
        }
        return item;
      }),
    );
  };

  return (
    <section className="formOptions__container">
      {/* Options Header */}
      <div className="formOptions__header--container">
        <h1>Additions/Enhancements</h1>
        <p>
          Please select your options/enhancements for your special occasion.
        </p>
      </div>

      {/* Options Selection Checkboxes */}
      <Form.Group className="formOptions__selection--container">
        {items.map((item) => (
          <div key={item.id} className="formCheckbox__item">
            <Form.Check
              id={`item-${item.id}--check`}
              name={`item-${item.id}--check`}
              className="formCheckbox__item--form-check-input"
              type="checkbox"
              label={item.name}
              aria-label={`select ${item.name}`}
              checked={item.selected}
              onChange={() => toggleCheckbox(item.id)}
            />

            <Form.Select
              id={`item-${item.id}--quantity`}
              name={`item-${item.id}--quantity`}
              className="formCheckbox__item--form-select"
              aria-label={`select quality for ${item.name}`}
              value={item.quantity}
              onChange={(e) => changeQuantity(item.id, e.target.value)}
              disabled={!item.selected}
              style={{ width: "60px" }}
            >
              {[...Array(item.available)].map((_, i) => {
                const value = i + 1;
                return (
                  <option key={value} value={value}>
                    {value}
                  </option>
                );
              })}
            </Form.Select>
          </div>
        ))}
      </Form.Group>
    </section>
  );
}
export default FormButtons;
